<template>
  <div>
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ $t(pagetitle) }}</h3>
      </div>
      <div style="border: 0px solid black; width:100%; padding: 10px">
        <div class="welcome" style="border: 0px solid red;">
          <row
            style="border:0px solid green;position: inherit;display:contents;width:100%;"
          >
            <div class="">
              <div class="panel with-nav-tabs panel-primary">
                <div class="panel-heading">
                  <ul class="nav nav-tabs">
                    <li
                      :class="apartmentId !== 0 ? 'active' : ''"
                      v-if="apartmentId !== 0"
                    >
                      <a href="#tab1primary" data-toggle="tab">{{
                        $t("apartment.apartmentTabList.apartmentImgTab")
                      }}</a>
                    </li>
                    <li :class="apartmentId !== 0 ? '' : 'active'">
                      <a href="#tab2primary" data-toggle="tab">{{
                        $t("apartment.apartmentTabList.apartmentInfoTab")
                      }}</a>
                    </li>
                    <li v-if="apartmentId !== 0">
                      <a href="#tab3primary" data-toggle="tab">{{
                        $t("apartment.apartmentTabList.apartmentOwnerTab")
                      }}</a>
                    </li>
                  </ul>
                </div>
                <div class="panel-body">
                  <div class="tab-content">
                    <div
                      :class="
                        apartmentId !== 0
                          ? 'tab-pane fade in active'
                          : 'tab-pane fade'
                      "
                      id="tab1primary"
                    >
                      <apartment-img-with-extra-info />
                    </div>
                    <div
                      :class="
                        apartmentId !== 0
                          ? 'tab-pane fade'
                          : 'tab-pane fade in active'
                      "
                      id="tab2primary"
                    >
                      <apartment-info-with-extra-info
                        :apartment-id="apartmentId"
                      />
                    </div>
                    <div class="tab-pane fade" id="tab3primary">
                      <div style="padding: 10px; background: #f4f3ef">
                        <div class="box box-primary">
                          <div class="box-body">
                            <div class="col-md-12">
                              <div class="row">
                                <form class="form-horizontal">
                                  <div class="box-body">
                                    <div class="col-sm-12 col-md-10 col-lg-8">
                                      <apartment-owner-detail
                                        :apartment_id="apartmentId"
                                        :apartment_code="apartmentCode"
                                        @mainperson-save="
                                          reload_apartment_details
                                        "
                                      />
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <apartment-contract-with-extra-info />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </row>
        </div>
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import utils from "@/lib/utils";
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import ApartmentInfoWithExtraInfo from "./ApartmentInfoWithExtraInfo";
import ApartmentImgWithExtraInfo from "./ApartmentImgWithExtraInfo";
import apartmentOwnerDetail from "./ApartmentOwnerDetail";
import ApartmentContractWithExtraInfo from "./ApartmentContractWithExtraInfo";
export default {
  components: {
    Loading,
    ApartmentInfoWithExtraInfo,
    ApartmentImgWithExtraInfo,
    apartmentOwnerDetail,
    ApartmentContractWithExtraInfo
  },
  data: () => ({
    isLoading: false,
    pagetitle: "apartment.editaddnew[0]",
    apartmentId: 0,
    apartmentCode: ""
  }),
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    reload_apartment_details: function() {
      let id = this.$route.params.id;
      if (parseInt(id) !== 0) {
        this.isLoading = true;
        this.GET_APARTMENT_DETAIL({ id: id }).then(
          function(res) {
            this.isLoading = false;
            this.apartmentCode = res.apartment_code;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
      }
    },
    ...mapActions([
      "GET_APARTMENT_DETAIL"
    ])
  },
  mounted() {
    let id = this.$route.params.id;
    if (parseInt(id) !== 0) {
      this.pagetitle = "apartment.editaddnew[1]";
      this.apartmentId = parseInt(id);
      this.reload_apartment_details();
    }
  }
};
</script>
<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL PRIMARY ***/
.with-nav-tabs.panel-primary .nav-tabs > li > a,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
}
.with-nav-tabs.panel-primary .nav-tabs > .open > a,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-primary .nav-tabs > li > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li > a:focus {
  color: #fff;
  background-color: #3071a9;
  border-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.active > a,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-primary .nav-tabs > li.active > a:focus {
  color: #428bca;
  background-color: #fff;
  border-color: #428bca;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #428bca;
  border-color: #3071a9;
}
.with-nav-tabs.panel-primary .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #fff;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #3071a9;
}
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-primary
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  background-color: #4a9fe9;
}
.with-nav-tabs.panel-primary .panel-body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentAddWithExtraInfo.vue